import { Modal } from "flowbite-react";
import FormInsertSubProduct from "../form/FormInsertSubProduct";

type Props = {
  onClose?: () => void
  onSave: (productId: string) => void
}

export default function ModalInsertSubProduct(props: Props) {

  const handleCloseModal = () => { props.onClose && props.onClose() }

  return (
    <Modal
      className='relative text-black h-full'
      onClose={() => handleCloseModal()}
      show={true}
    >
      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">{'Selecione SubItem'}</h2>
      </Modal.Header>
      <Modal.Body className='text-black dark:text-black'>
        <FormInsertSubProduct onSubmit={handleCloseModal} />
      </Modal.Body>
    </Modal>
  )
}